import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { withFirestore, withFirebase } from 'react-redux-firebase';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';

import {
  text__primary,
  text__primary_dark,
  white,
  deepPurple,
  grey,
  grey_dark,
  text__secondary
} from '../../style';

const styles = theme => ({
  root: {},
  usersContainer: {
    maxWidth: '250px',
    minWidth: '250px',
    borderRight: '1px solid rgba(0, 0, 0, 0.12)'
  },
  userList: {
    overflowY: 'auto',
    display: 'block',
    height: 'calc(100vh - 73px - 70px)'
  },
  convoContainer: {
    width: '100%'
  },
  userPic: {
    width: '50px',
    height: '50px',
    background: '#ffffff',
    '& > img': {
      borderRadius: '50%',
      width: '100%',
      height: '100%'
    }
  },
  userItem: {
    width: '100%',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    minHeight: '60px',
    cursor: 'pointer',
    background: '#ffffff',
    '& > *': {
      padding: 20
    }
  },
  selectedUserItem: {
    backgroundColor: '#FBFAFF',
    borderRight: 'solid 3px #22c26e'
  },
  nameContainer: {
    marginLeft: '10px',
    height: '20px'
  },
  search: {
    background: grey,
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '5px 10px'
  },
  searchInput: {
    width: '100%'
  },
  header: {
    background: white,
    padding: '15px 10px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  badge: {
    '& > .MuiBadge-badge': {
      top: '7px',
      right: '7px',
      height: '14px',
      minWidth: '14px'
    }
  },
  drawerButtonGrid: {
    maxWidth: 50
  },
  drawerButton: {
    minWidth: 'initial',
    position: 'absolute',
    top: '90px',
    background: '#ffffff',
    padding: '5px 0',
    borderLeft: 'none',
    borderTopLeftRadius: 'initial',
    borderBottomLeftRadius: 'initial'
  },
  messageTip: {
    marginTop: '5px',
    marginBottom: '5px',
    marginLeft: '5px'
  },
  messageDivider: {
    marginTop: '20px',
    marginBottom: '20px'
  },
  conversationContainer: {
    width: '200px'
  }
});

const mapStateToProps = ({
  firebase: { auth, profile },
  firestore: { ordered }
}) => {
  return {
    auth,
    profile,
    dealList: ordered.deals
  };
};

export default compose(
  connect(
    mapStateToProps,
    null
  ),
  withFirestore,
  withFirebase,
  withProps(({ auth }) => ({
    auth
  })),
  withRouter,
  withStyles(styles)
);



// WEBPACK FOOTER //
// ./src/components/messaging/MessagePage.enhancer.js